module.exports = __webpack_public_path__ + "static/media/redfuse-logo.186ef180.png";